import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import InstallPrompt from "@/components/InstallPrompt";
import CookieConsent from "@/components/CookieConsent";

import Login from "@/pages/Login";
import Registro from "@/pages/Registro";
import Verificar from "@/pages/Verificar";
import Recuperar from "@/pages/Recuperar";
import Restablecer from "@/pages/Restablecer";
import Activar from "@/pages/Activar";
import Legal from "@/pages/Legal";
import Ayuda from "@/pages/Ayuda";
import Dashboard from "@/pages/Dashboard";
import Documentos from "@/pages/Documentos";
import Norma from "@/pages/Norma";
import Calidad from "@/pages/Calidad";
import Incidencias from "@/pages/Incidencias";
import Inspector from "@/pages/Inspector";
import Admin from "@/pages/Admin";
import Ajustes from "@/pages/Ajustes";
import SubidaIA from "@/pages/SubidaIA";
import DiagnosticoRapido from "@/pages/DiagnosticoRapido";
import Gaps from "@/pages/Gaps";
import Alertas from "@/pages/Alertas";
import Informes from "@/pages/Informes";
import Usuarios from "@/pages/Usuarios";
import Tenants from "@/pages/Tenants";
import Nucleo from "@/pages/Nucleo";
import Traza from "@/pages/Traza";
import Trazabilidad from "@/pages/Trazabilidad";
import Etiquetas from "@/pages/Etiquetas";
import Lotes from "@/pages/Lotes";
import Produccion from "@/pages/Produccion";
import Expediciones from "@/pages/Expediciones";
import Showcase from "@/pages/Showcase";
import ExportVideo from "@/pages/ExportVideo";

const page = (el, roles) => (
  <ProtectedRoute roles={roles}>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function App() {
  const isShowcase = typeof window !== "undefined" && window.location.pathname === "/showcase";
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<Registro />} />
          <Route path="/verificar" element={<Verificar />} />
          <Route path="/recuperar" element={<Recuperar />} />
          <Route path="/restablecer" element={<Restablecer />} />
          <Route path="/legal/:clave" element={<Legal />} />
          <Route path="/showcase" element={<Showcase />} />
          <Route path="/" element={page(<Dashboard />)} />
          <Route path="/activar" element={page(<Activar />)} />
          <Route path="/ayuda" element={page(<Ayuda />)} />
          <Route path="/documentos" element={page(<Documentos />)} />
          <Route path="/subir-ia" element={page(<SubidaIA />, ["superadmin", "admin", "calidad"])} />
          <Route path="/diagnostico-rapido" element={page(<DiagnosticoRapido />, ["superadmin", "admin", "calidad", "operario", "consulta"])} />
          <Route path="/norma" element={page(<Norma />)} />
          <Route path="/calidad" element={page(<Calidad />, ["superadmin", "admin", "calidad", "operario"])} />
          <Route path="/incidencias" element={page(<Incidencias />)} />
          <Route path="/maestros" element={page(<Traza />, ["superadmin", "admin", "calidad", "operario", "consulta"])} />
          <Route path="/traza" element={page(<Trazabilidad />, ["superadmin", "admin", "calidad", "operario", "consulta"])} />
          <Route path="/etiquetas" element={page(<Etiquetas />, ["superadmin", "admin", "calidad", "operario"])} />
          <Route path="/lotes" element={page(<Lotes />, ["superadmin", "admin", "calidad", "operario", "consulta"])} />
          <Route path="/produccion" element={page(<Produccion />, ["superadmin", "admin", "calidad", "operario", "consulta"])} />
          <Route path="/expediciones" element={page(<Expediciones />, ["superadmin", "admin", "calidad", "operario", "consulta"])} />
          <Route path="/inspector" element={page(<Inspector />)} />
          <Route path="/ajustes" element={page(<Ajustes />, ["superadmin", "admin", "calidad", "operario", "consulta"])} />
          <Route path="/admin" element={page(<Admin />, ["superadmin"])} />
          <Route path="/admin/export" element={page(<ExportVideo />, ["superadmin"])} />
          <Route path="/gaps" element={page(<Gaps />)} />
          <Route path="/alertas" element={page(<Alertas />)} />
          <Route path="/informes" element={page(<Informes />)} />
          <Route path="/usuarios" element={page(<Usuarios />, ["superadmin", "admin"])} />
          <Route path="/nucleo" element={page(<Nucleo />, ["superadmin", "admin"])} />
          <Route path="/tenants" element={page(<Tenants />, ["superadmin"])} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      {!isShowcase && <InstallPrompt />}
      {!isShowcase && <CookieConsent />}
    </AuthProvider>
  );
}

export default App;
